module.exports = __webpack_public_path__ + "media/images/indicators/falkenmark-f629b157b283654e362d2e1a3e238787.png";